import React, { PureComponent } from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

let globalId = 0;

export default class CustomTooltip extends PureComponent {
  constructor(props) {
    super(props);
    this.tooltipId = ++globalId;
  }

  render() {
    return !this.props.disabled ? (
      <OverlayTrigger
        placement={this.props.placement || 'bottom'}
        overlay={
          <Tooltip id={`custom-tooltip-${this.tooltipId}`}>
            {this.props.tooltip}
          </Tooltip>
        }
      >
        {this.props.children}
      </OverlayTrigger>
    ) : (
      this.props.children
    );
  }
}
